import { LoadingButton } from '@mui/lab';
import { Box, Button } from '@mui/material';
import React, { useCallback } from 'react';
import { BUTTON_VARIANTS } from '../../../../constants/constants';
import I18n from '../../../../i18n/I18n';
import { Icons } from '../../../../icons/Icons';

type NoteFormActionsProps = {
    noteId?: string;
    onSave: () => void;
    isSaving?: boolean;
    onCancel: () => void;
    disableSave?: boolean;
    onShare?: () => void;
    disabled?: boolean;
    canShare?: boolean;
};

export default function NoteFormActions({
    noteId,
    onSave,
    isSaving = false,
    onCancel,
    disableSave = false,
    onShare = undefined,
    disabled = false,
    canShare = false
}: NoteFormActionsProps) {
    const isExistingNote = Boolean(noteId);

    const handleShareClick = useCallback(() => {
        if (onShare) {
            onShare();
        }
    }, [onShare]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
            {onShare && (!isExistingNote || canShare) ? (
                <Button
                    variant={BUTTON_VARIANTS.text}
                    startIcon={<Icons.Share />}
                    onClick={handleShareClick}
                    disabled={disabled || disableSave}
                >
                    <I18n token="notes.share" />
                </Button>
            ) : (
                <Box />
            )}
            <Box sx={{ display: 'flex' }}>
                <Button variant={BUTTON_VARIANTS.text} sx={{ mr: 2 }} onClick={onCancel} disabled={disabled}>
                    <I18n token="dialog.cancel" />
                </Button>
                <LoadingButton
                    variant={BUTTON_VARIANTS.contained}
                    onClick={onSave}
                    disabled={disabled || disableSave}
                    loading={isSaving}
                >
                    <I18n token="form.button.save" />
                </LoadingButton>
            </Box>
        </Box>
    );
}
